import React from "react";
import Calculator from "./Calculator";

interface DraggableCalculatorProps {
  isOpen: boolean;
  onClose: () => void;
  onResult?: (result: number) => void;
}

const DraggableCalculator: React.FC<DraggableCalculatorProps> = (props) => {
  return <Calculator {...props} />;
};

export default DraggableCalculator;
